import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { afterItems, beforeItems } from "../data/landing";
export function BeforeAfter() {
  return <section className="bg-navy px-4 py-16 sm:py-20" aria-labelledby="before-after" data-id="element-35" data-mp="3ofhx3ds4fjys">
      <div className="mx-auto max-w-5xl" data-id="element-36" data-mp="3sfrzyhkm9u9f">
        <SectionHeading title={<span id="before-after" data-id="element-38" data-mp="3ep6gaqnc9gah">
              From uncertainty when interpreting tests… <span className="text-cyan" data-id="element-39" data-mp="3jgy814i8ds27">to a more structured clinical reasoning process</span>
            </span>} intro={<>
              <p data-id="element-40" data-mp="34pxq88vlglte">Knowing how to perform an orthopedic test is one thing.</p>
              <p className="mt-2 font-semibold text-white" data-id="element-41" data-mp="39r4y07xqll02">
                Understanding what its findings mean within the patient's complete clinical presentation is another.
              </p>
            </>} data-id="element-37" data-mp="3epyd24so9k2c" />

        <div className="grid gap-5 md:grid-cols-2" data-id="element-42" data-mp="x4k3r0bzjy6t">
          <div className="rounded-3xl border-2 border-before/40 bg-before/[0.07] p-5 sm:p-7" data-id="element-43" data-mp="x38x8sr5occ0">
            <div className="mb-5 flex items-center gap-3" data-id="element-44" data-mp="t26x89pezw8z">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-before text-white" data-id="element-45" data-mp="172hr7lm0tqyd">
                <XIcon className="h-6 w-6" strokeWidth={3} aria-hidden="true" data-id="element-46" data-mp="12356b6epmtyf" />
              </span>
              <h3 className="font-display text-3xl font-extrabold uppercase text-before" data-id="element-47" data-mp="edj74iyc8eqf">Before</h3>
            </div>
            <ul className="space-y-3.5" data-id="element-48" data-mp="9g0t4e5gr9bk">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-[16px] leading-snug text-slate-200" data-id="element-49" data-mp="o45exqztc0yk">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-before" strokeWidth={3} aria-hidden="true" data-id="element-50" data-mp="jcnhve0wukiv" />
                  <span data-id="element-51" data-mp="3rrxc5zyk6lg3">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-after/50 bg-after/[0.08] p-5 sm:p-7" data-id="element-52" data-mp="3msukdh7labq2">
            <div className="mb-5 flex items-center gap-3" data-id="element-53" data-mp="1qpodw0bzyjiw">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-after text-ink" data-id="element-54" data-mp="1vpu9tspaus6s">
                <CheckIcon className="h-6 w-6" strokeWidth={3} aria-hidden="true" data-id="element-55" data-mp="20gssgyxrg2d7" />
              </span>
              <h3 className="font-display text-3xl font-extrabold uppercase leading-none text-after" data-id="element-56" data-mp="24hw6rh05tqcb">
                After <span className="block text-base font-bold text-white" data-id="element-57" data-mp="17ses4cj78tyh">With the Blueprint™</span>
              </h3>
            </div>
            <ul className="space-y-3.5" data-id="element-58" data-mp="1crri365dah5a">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-[16px] font-medium leading-snug text-white" data-id="element-59" data-mp="1gribziq6xde1">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-after" strokeWidth={3} aria-hidden="true" data-id="element-60" data-mp="1lsftru7ag5f0" />
                  <span data-id="element-61" data-mp="2s76yya3g2ceu">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <CtaButton className="mt-10" label="I want a more structured approach" data-id="element-62" data-mp="2x8wea1xp9c8q" />
      </div>
    </section>;
}